import * as React from "react";
import {CSSProperties} from "react";

export class WPBasicColumn extends React.Component<WPBasicColumnProps, WPBasicColumnState> {
    static defaultProps: Partial<WPBasicColumnProps> = {
        Actions:[],
        IsClickable:false,
        IsPrimary:false,
        Width:200,
    };

    constructor(props: WPBasicColumnProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            null
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface WPBasicColumnProps {
    IsSortable?: boolean;
    PropertyName: string;
    Title: string;
    Actions?: WPRowActions[];
    IsClickable?: boolean;
    IsPrimary: boolean;
    Formatter: (value: any, column: WPBasicColumnProps, row: any) => any;
    styles:CSSProperties;
    Width?:number;
    HeaderStyle:CSSProperties;
    Raw:boolean;
}



export interface WPRowActions{
    Id:string;
    Title:string;
    ClassName?:string;
}
interface WPBasicColumnState {

}

//#endregion "My Region"